/* eslint-disable react-refresh/only-export-components */
import './index.css'

import { QueryClientProvider } from '@tanstack/react-query'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { TooltipProvider } from '#components/ui/tooltip'

import { useAuth } from './hooks/use-auth'
import { posthog } from './lib/posthog'
import { queryClient } from './lib/query-client'
import { initSentry } from './lib/sentry'
import { supabase } from './lib/supabase'
import { routeTree } from './routeTree.gen'
import { useWaiterStore } from './stores/use-waiter-store'

initSentry()

export const router = createRouter({
  routeTree,
  context: { queryClient, auth: undefined! },
  defaultPreload: 'intent',
  defaultPreloadDelay: 0,
})

supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'SIGNED_IN' || event === 'INITIAL_SESSION') {
    const user = session?.user

    if (user) {
      posthog.identify(user.id)
    }
  }

  if (event === 'SIGNED_OUT') {
    posthog.reset()
  }

  if (
    event === 'SIGNED_IN' ||
    event === 'SIGNED_OUT' ||
    event === 'TOKEN_REFRESHED'
  ) {
    queryClient.invalidateQueries({ queryKey: ['auth-user'] })
  }
})

const waiter = useWaiterStore.getState().waiter
if (waiter) {
  posthog.identify(waiter.id, {
    role: waiter.role,
    tenant_id: waiter.tenant_id,
  })
}

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

function InnerApp() {
  const auth = useAuth()

  return <RouterProvider router={router} context={{ queryClient, auth }} />
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <InnerApp />
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
)
